import Slider from '../helpers/Slider';

export default class TestimonialsBlock {
    constructor(root) {
        this.root = root;
        this.slider = this.root.querySelector('.js-slider');

        if(this.slider) {
            this.listings_slider = new Slider(this.slider, {
                hideArrows: false,
                swiperOptions: {
                    slidesPerView: 1,
                    spaceBetween: 45,
                    breakpoints: {
                        1000: {
                            slidesPerView: 4,
                        },
                        700: {
                            slidesPerView: 3,
                        },
                        500: {
                            slidesPerView: 2,
                        }
                    }
                }
            });
        }
    }
}
